module.exports = __webpack_public_path__ + "static/media/products_specification_en.c2d7ad1b.md";